import { render } from "./HeartbeatPulse.vue?vue&type=template&id=2b331a59&scoped=true"
import script from "./HeartbeatPulse.vue?vue&type=script&lang=js"
export * from "./HeartbeatPulse.vue?vue&type=script&lang=js"

import "./HeartbeatPulse.vue?vue&type=style&index=0&id=2b331a59&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b331a59"]])

export default __exports__